import "./ui/errors.css";
import Stars from "./ui/Stars";
import AstronautPorthole from "./ui/AstronautPorthole";
import ErrorContent, { type ErrorPageContent } from "./ui/ErrorContent";

const ERROR_PAGES: Record<"401" | "404", ErrorPageContent> = {
	"401": {
		titlePrefix: "Esta área é ",
		titleHighlight: "restrita",
		titleSuffix: ".",
		description:
			"Sua credencial não foi reconhecida para acessar esta área. Faça login para continuar ou volte para o início.",
		primaryHref: "/sign-in",
		primaryLabel: "Reautenticar",
		secondaryLabel: "Voltar",
		footerNote: "Recarregue a página.",
	},
	"404": {
		titlePrefix: "Você saiu da ",
		titleHighlight: "rota",
		titleSuffix: ".",
		description: "Esta página não existe ou foi movida. Vamos te levar de volta para um lugar seguro.",
		primaryHref: "/",
		primaryLabel: "Voltar para o início",
		secondaryLabel: "Voltar uma página",
		footerNote: "Confira a URL ou fale com o suporte.",
	},
};

type ErrorPageViewProps = {
	readonly sourcePage: "401" | "404";
};

export default function ErrorPageView({ sourcePage }: ErrorPageViewProps) {
	const content = ERROR_PAGES[sourcePage];

	return (
		<div className="relative isolate min-h-dvh w-full bg-[#050813] text-white">
			{/* Camada decorativa recortada (nunca gera scroll) */}
			<div className="pointer-events-none absolute inset-0 overflow-hidden">
				{/* Fundo base */}
				<div className="absolute inset-0 bg-[radial-gradient(circle_at_78%_50%,#141c3a_0%,#0a0f22_45%,#050813_100%)]" />

				{/* Estrelas */}
				<Stars className="opacity-50" />

				{/* Nebulosas */}
				<div className="absolute -top-40 -right-20 h-[620px] w-[620px] rounded-full bg-indigo-500/20 blur-[100px] animate-[scDrift_18s_ease-in-out_infinite]" />
				<div className="absolute -bottom-44 -left-24 h-[520px] w-[520px] rounded-full bg-fuchsia-500/15 blur-[90px] animate-[scDrift_21s_ease-in-out_infinite_reverse]" />

				{/* Código fantasma no fundo */}
				<span
					aria-hidden
					className="absolute top-1/2 right-[6%] -translate-y-1/2 text-[220px] leading-none font-bold tracking-tighter text-transparent select-none [-webkit-text-stroke:1.5px_rgba(255,255,255,0.06)] sm:text-[420px] lg:text-[640px]"
				>
					{sourcePage}
				</span>
			</div>

			<main className="relative z-10 mx-auto flex min-h-dvh max-w-7xl flex-col items-center justify-center gap-8 px-6 py-10 text-center sm:gap-10 lg:grid lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-0 lg:px-8 lg:py-0 lg:text-left">
				<ErrorContent content={content} />
				<AstronautPorthole sourcePage={sourcePage} />
			</main>
		</div>
	);
}
